import React from "react"

import Skeleton from "@components/Skeleton/Skeleton"

export const HeaderSkeleton = [
    {
        span: 24,
        height: "252px",
        classes: "alignCenter marginTop-24",
    },
]

const offersSection = [
    {
        height: "206px",
        classes: "justifyBetween marginTop-64",
        columns: [
            {
                height: "206px",
                rows: [
                    { span: 8, height: "60px" },
                    { span: 8, height: "90px", classes: "marginTop-8" },
                    { span: 8, height: "40px", classes: "marginTop-8" },
                ],
            },
            {
                height: "206px",
                rows: [
                    { span: 8, height: "60px" },
                    { span: 8, height: "90px", classes: "marginTop-8" },
                    { span: 8, height: "40px", classes: "marginTop-8" },
                ],
            },
            {
                height: "206px",
                rows: [
                    { span: 8, height: "60px" },
                    { span: 8, height: "90px", classes: "marginTop-8" },
                    { span: 8, height: "40px", classes: "marginTop-8" },
                ],
            },
        ],
    },
]

function PageSkeleton() {
    return (
        <div>
            <Skeleton config={HeaderSkeleton} />
            <Skeleton config={offersSection} />
        </div>
    )
}

export default PageSkeleton
